var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8315 13.1944L12.9821 7.19004C12.7358 6.93665 12.2626 6.93665 12.0163 7.19004L6.16686 13.1944C6.08282 13.2807 6.02764 13.3876 6.008 13.5022C5.98835 13.6168 6.00509 13.7343 6.05618 13.8403C6.10727 13.9463 6.19053 14.0364 6.29587 14.0996C6.40122 14.1628 6.52414 14.1965 6.64977 14.1965H7.94964V18.3996C7.94964 18.5588 8.01811 18.7115 8.14 18.8241C8.26188 18.9367 8.4272 19 8.59957 19H16.3988C16.5712 19 16.7365 18.9367 16.8584 18.8241C16.9803 18.7115 17.0487 18.5588 17.0487 18.3996V14.1965H18.3486C18.4745 14.197 18.5978 14.1637 18.7035 14.1005C18.8092 14.0374 18.8927 13.9472 18.9439 13.841C18.9951 13.7348 19.0118 13.6171 18.9918 13.5022C18.9718 13.3874 18.9161 13.2805 18.8315 13.1944Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ebaeadf6a873851facb5f6b51c807d29.svg";
export { ForwardRef as ReactComponent };